// Diverse cartoon-style profile icons using emoji
// Organized by categories for better selection experience

export interface ProfileIcon {
  id: string;
  emoji: string;
  name: string;
  category: 'diverse' | 'animals' | 'fantasy' | 'professions' | 'expressions';
}

export const profileIcons: ProfileIcon[] = [
  // Diverse Human Avatars
  { id: 'person-1', emoji: '👤', name: 'Person', category: 'diverse' },
  { id: 'person-2', emoji: '👨', name: 'Man', category: 'diverse' },
  { id: 'person-3', emoji: '👩', name: 'Woman', category: 'diverse' },
  { id: 'person-4', emoji: '🧑', name: 'Adult', category: 'diverse' },
  { id: 'person-5', emoji: '👨‍🦱', name: 'Man with Curly Hair', category: 'diverse' },
  { id: 'person-6', emoji: '👩‍🦱', name: 'Woman with Curly Hair', category: 'diverse' },
  { id: 'person-7', emoji: '👨‍🦰', name: 'Man with Red Hair', category: 'diverse' },
  { id: 'person-8', emoji: '👩‍🦰', name: 'Woman with Red Hair', category: 'diverse' },
  { id: 'person-9', emoji: '👨‍🦳', name: 'Man with White Hair', category: 'diverse' },
  { id: 'person-10', emoji: '👩‍🦳', name: 'Woman with White Hair', category: 'diverse' },
  { id: 'person-11', emoji: '👨‍🦲', name: 'Bald Man', category: 'diverse' },
  { id: 'person-12', emoji: '👩‍🦲', name: 'Bald Woman', category: 'diverse' },
  { id: 'person-13', emoji: '🧑‍🦱', name: 'Person with Curly Hair', category: 'diverse' },
  { id: 'person-14', emoji: '🧑‍🦰', name: 'Person with Red Hair', category: 'diverse' },
  { id: 'person-15', emoji: '🧑‍🦳', name: 'Person with White Hair', category: 'diverse' },
  { id: 'person-16', emoji: '🧑‍🦲', name: 'Bald Person', category: 'diverse' },
  
  // Professions & Roles
  { id: 'prof-1', emoji: '👨‍💼', name: 'Business Person', category: 'professions' },
  { id: 'prof-2', emoji: '👩‍💼', name: 'Business Woman', category: 'professions' },
  { id: 'prof-3', emoji: '👨‍🔬', name: 'Scientist', category: 'professions' },
  { id: 'prof-4', emoji: '👩‍🔬', name: 'Woman Scientist', category: 'professions' },
  { id: 'prof-5', emoji: '👨‍💻', name: 'Technologist', category: 'professions' },
  { id: 'prof-6', emoji: '👩‍💻', name: 'Woman Technologist', category: 'professions' },
  { id: 'prof-7', emoji: '👨‍🎨', name: 'Artist', category: 'professions' },
  { id: 'prof-8', emoji: '👩‍🎨', name: 'Woman Artist', category: 'professions' },
  { id: 'prof-9', emoji: '👨‍🏫', name: 'Teacher', category: 'professions' },
  { id: 'prof-10', emoji: '👩‍🏫', name: 'Woman Teacher', category: 'professions' },
  { id: 'prof-11', emoji: '👨‍⚕️', name: 'Health Worker', category: 'professions' },
  { id: 'prof-12', emoji: '👩‍⚕️', name: 'Woman Health Worker', category: 'professions' },
  { id: 'prof-13', emoji: '👨‍🍳', name: 'Chef', category: 'professions' },
  { id: 'prof-14', emoji: '👩‍🍳', name: 'Woman Chef', category: 'professions' },
  { id: 'prof-15', emoji: '👨‍🎤', name: 'Singer', category: 'professions' },
  { id: 'prof-16', emoji: '👩‍🎤', name: 'Woman Singer', category: 'professions' },
  
  // Animals
  { id: 'animal-1', emoji: '🐱', name: 'Cat', category: 'animals' },
  { id: 'animal-2', emoji: '🐶', name: 'Dog', category: 'animals' },
  { id: 'animal-3', emoji: '🐰', name: 'Rabbit', category: 'animals' },
  { id: 'animal-4', emoji: '🐻', name: 'Bear', category: 'animals' },
  { id: 'animal-5', emoji: '🐼', name: 'Panda', category: 'animals' },
  { id: 'animal-6', emoji: '🐨', name: 'Koala', category: 'animals' },
  { id: 'animal-7', emoji: '🦊', name: 'Fox', category: 'animals' },
  { id: 'animal-8', emoji: '🐯', name: 'Tiger', category: 'animals' },
  { id: 'animal-9', emoji: '🦁', name: 'Lion', category: 'animals' },
  { id: 'animal-10', emoji: '🐸', name: 'Frog', category: 'animals' },
  { id: 'animal-11', emoji: '🐷', name: 'Pig', category: 'animals' },
  { id: 'animal-12', emoji: '🐮', name: 'Cow', category: 'animals' },
  
  // Fantasy & Fun
  { id: 'fantasy-1', emoji: '🦸', name: 'Superhero', category: 'fantasy' },
  { id: 'fantasy-2', emoji: '🦸‍♂️', name: 'Man Superhero', category: 'fantasy' },
  { id: 'fantasy-3', emoji: '🦸‍♀️', name: 'Woman Superhero', category: 'fantasy' },
  { id: 'fantasy-4', emoji: '🧙', name: 'Mage', category: 'fantasy' },
  { id: 'fantasy-5', emoji: '🧙‍♂️', name: 'Man Mage', category: 'fantasy' },
  { id: 'fantasy-6', emoji: '🧙‍♀️', name: 'Woman Mage', category: 'fantasy' },
  { id: 'fantasy-7', emoji: '🧚', name: 'Fairy', category: 'fantasy' },
  { id: 'fantasy-8', emoji: '🧚‍♂️', name: 'Man Fairy', category: 'fantasy' },
  { id: 'fantasy-9', emoji: '🧚‍♀️', name: 'Woman Fairy', category: 'fantasy' },
  { id: 'fantasy-10', emoji: '🧛', name: 'Vampire', category: 'fantasy' },
  { id: 'fantasy-11', emoji: '🧛‍♂️', name: 'Man Vampire', category: 'fantasy' },
  { id: 'fantasy-12', emoji: '🧛‍♀️', name: 'Woman Vampire', category: 'fantasy' },
  { id: 'fantasy-13', emoji: '🤖', name: 'Robot', category: 'fantasy' },
  { id: 'fantasy-14', emoji: '👽', name: 'Alien', category: 'fantasy' },
  { id: 'fantasy-15', emoji: '🦄', name: 'Unicorn', category: 'fantasy' },
  { id: 'fantasy-16', emoji: '🦋', name: 'Butterfly', category: 'fantasy' },
  
  // Expressions & Moods
  { id: 'expr-1', emoji: '😀', name: 'Grinning', category: 'expressions' },
  { id: 'expr-2', emoji: '😃', name: 'Happy', category: 'expressions' },
  { id: 'expr-3', emoji: '😄', name: 'Smiling', category: 'expressions' },
  { id: 'expr-4', emoji: '😁', name: 'Beaming', category: 'expressions' },
  { id: 'expr-5', emoji: '😊', name: 'Smiling Eyes', category: 'expressions' },
  { id: 'expr-6', emoji: '😎', name: 'Cool', category: 'expressions' },
  { id: 'expr-7', emoji: '🤓', name: 'Nerd', category: 'expressions' },
  { id: 'expr-8', emoji: '🧐', name: 'Monocle', category: 'expressions' },
  { id: 'expr-9', emoji: '😏', name: 'Smirking', category: 'expressions' },
  { id: 'expr-10', emoji: '😌', name: 'Relieved', category: 'expressions' },
  { id: 'expr-11', emoji: '🤗', name: 'Hugging', category: 'expressions' },
  { id: 'expr-12', emoji: '🤔', name: 'Thinking', category: 'expressions' },
];

export const getIconById = (id: string): ProfileIcon | undefined => {
  return profileIcons.find(icon => icon.id === id);
};

export const getIconsByCategory = (category: ProfileIcon['category']): ProfileIcon[] => {
  return profileIcons.filter(icon => icon.category === category);
};

export const getDefaultIcon = (): ProfileIcon => {
  return profileIcons[0]; // Default to first icon
};
